import React from 'react'
import img from '../../assets/Presskit/Bestia-Logo/Bestia.png'


export const Matches = () => {
    return (
        <div className='container'>
            
            <div className='match'>

                <div className='team-1'>
                    <img src={img} alt="" />
                    <p>Bestia</p>
                </div>

                <div className='dateMatch'>
                    <p>19:00HS</p>
                    <span>2 de julio</span>
                </div>

                <div className='team-2'>
                    <img src="https://img-cdn.hltv.org/teamlogo/cRCqqg_3nBVCfizJGJZR7Y.png?ixlib=java-2.1.0&w=100&s=f4eca57fedc3a9673529b27a92d771ab" alt="" />
                    <p>Windingo</p>
                </div>

            </div>

            <div className='match'>

                <div className='team-1'>
                    <img src={img} alt="" />
                    <p>Bestia</p>
                </div>

                <div className='dateMatch'>
                    <p>19:00HS</p>
                    <span>2 de julio</span>
                </div>

                <div className='team-2'>
                    <img src="https://img-cdn.hltv.org/teamlogo/cRCqqg_3nBVCfizJGJZR7Y.png?ixlib=java-2.1.0&w=100&s=f4eca57fedc3a9673529b27a92d771ab" alt="" />
                    <p>Windingo</p>
                </div>

            </div>

            <div className='match'>

                <div className='team-1'>
                    <img src={img} alt="" />
                    <p>Bestia</p>
                </div>

                <div className='dateMatch'>
                    <p>19:00HS</p>
                    <span>2 de julio</span>
                </div>

                <div className='team-2'>
                    <img src="https://img-cdn.hltv.org/teamlogo/cRCqqg_3nBVCfizJGJZR7Y.png?ixlib=java-2.1.0&w=100&s=f4eca57fedc3a9673529b27a92d771ab" alt="" />
                    <p>Windingo</p>
                </div>

            </div>


            <div className='match'>

                <div className='team-1'>
                    <img src={img} alt="" />
                    <p>Bestia</p>
                </div>

                <div className='dateMatch'>
                    <p>19:00HS</p>
                    <span>2 de julio</span>
                </div>

                <div className='team-2'>
                    <img src="https://img-cdn.hltv.org/teamlogo/cRCqqg_3nBVCfizJGJZR7Y.png?ixlib=java-2.1.0&w=100&s=f4eca57fedc3a9673529b27a92d771ab" alt="" />
                    <p>Windingo</p>
                </div>

            </div>

            <div className='match'>

                <div className='team-1'>
                    <img src={img} alt="" />
                    <p>Bestia</p>
                </div>

                <div className='dateMatch'>
                    <p>19:00HS</p>
                    <span>2 de julio</span>
                </div>

                <div className='team-2'>
                    <img src="https://img-cdn.hltv.org/teamlogo/cRCqqg_3nBVCfizJGJZR7Y.png?ixlib=java-2.1.0&w=100&s=f4eca57fedc3a9673529b27a92d771ab" alt="" />
                    <p>Windingo</p>
                </div>

            </div>

            <div className='match'>

                <div className='team-1'>
                    <img src={img} alt="" />
                    <p>Bestia</p>
                </div>

                <div className='dateMatch'>
                    <p>19:00HS</p>
                    <span>2 de julio</span>
                </div>

                <div className='team-2'>
                    <img src="https://img-cdn.hltv.org/teamlogo/cRCqqg_3nBVCfizJGJZR7Y.png?ixlib=java-2.1.0&w=100&s=f4eca57fedc3a9673529b27a92d771ab" alt="" />
                    <p>Windingo</p>
                </div>

            </div>


        </div>
    )
}
